import { Action } from '@ngrx/store';
import { State } from './first-steps.reducer';

export const CHANGE_CURRENT_STATE = 'CHANGE_CURRENT_STATE';
export const CURRENT_STATE_CHANGED = 'CURRENT_STATE_CHANGED';
export const CHANGE_STATES_FLOW_IF_EMPTY = 'CHANGE_STATES_FLOW_IF_EMPTY';
export const CHANGE_STATE_META = 'CHANGE_STATE_META';
export const GO_TO_NEXT_STATE = 'GO_TO_NEXT_STATE';
export const FINISH_FIRST_STEPS = 'FINISH_FIRST_STEPS';
export const LOAD_INITIAL_STATE = 'LOAD_INITIAL_STATE';
export const GO_TO_NEXT_APP_CONFIGURATION = 'GO_TO_NEXT_APP_CONFIGURATION';

export class ChangeCurrentStateAction implements Action {
  readonly type = CHANGE_CURRENT_STATE;

  constructor(public payload: State) {}
}

export class CurrentStateChangedAction implements Action {
  readonly type = CURRENT_STATE_CHANGED;

  constructor(public payload: State) {}
}

export class ChangeStatesFlowIfEmptyAction implements Action {
  readonly type = CHANGE_STATES_FLOW_IF_EMPTY;

  constructor(public payload: State[]) {}
}

export class ChangeStateMetaAction implements Action {
  readonly type = CHANGE_STATE_META;

  constructor(public payload: any) {}
}

export class GoToNextStateAction implements Action {
  readonly type = GO_TO_NEXT_STATE;

  constructor() {}
}

export class FinishFirstStepsAction implements Action {
  readonly type = FINISH_FIRST_STEPS;

  constructor() {}
}

export class LoadInitialStateAction implements Action {
  readonly type = LOAD_INITIAL_STATE;

  constructor() {}
}

export class GoToNextAppConfigurationAction implements Action {
  readonly type = GO_TO_NEXT_APP_CONFIGURATION;

  constructor() {}
}

export type FirstStepsAction =
  | ChangeCurrentStateAction
  | CurrentStateChangedAction
  | ChangeStatesFlowIfEmptyAction
  | ChangeStateMetaAction
  | GoToNextStateAction
  | FinishFirstStepsAction
  | GoToNextAppConfigurationAction
  | LoadInitialStateAction;
